import { type ReactNode, useMemo, useState } from 'react';
import { HoaDonMuaHangTrongNuocSearchContext } from './useHoaDonMuaHangTrongNuocSearchContext';
import { useHoaDonMuaHangTrongNuocExport } from '../hooks';
import { MA_CHUNG_TU, QUERY_KEYS } from '@/constants';
import { useCRUD } from '@/hooks';

export function HoaDonMuaHangTrongNuocSearchProvider({ children }: { children: ReactNode }) {
  const { exportToExcel, canExport, isExporting } = useHoaDonMuaHangTrongNuocExport();
  const [ngayCt, setNgayCt] = useState<string | undefined>(undefined);
  const [isImportDialogOpen, setIsImportDialogOpen] = useState(false);
  const { data } = useCRUD({
    endpoint: `${QUERY_KEYS.MA_GIAO_DICH}?ma_ct=${MA_CHUNG_TU.MUA_HANG.HOA_DON_MUA_HANG_TRONG_NUOC}`
  });

  const transactionOptions = useMemo(
    () =>
      data.map(item => ({
        value: item.uuid,
        label: item.ten_gd
      })),
    [data]
  );

  const value = useMemo(
    () => ({
      exportToExcel,
      canExport,
      isExporting,
      ngayCt,
      setNgayCt,
      isImportDialogOpen,
      openImportDialog: () => setIsImportDialogOpen(true),
      closeImportDialog: () => setIsImportDialogOpen(false),
      transactionOptions
    }),
    [canExport, exportToExcel, isExporting, isImportDialogOpen, ngayCt, transactionOptions]
  );

  return (
    <HoaDonMuaHangTrongNuocSearchContext.Provider value={value}>
      {children}
    </HoaDonMuaHangTrongNuocSearchContext.Provider>
  );
}
